import { MicroappFbsTarif } from './microapp-fbs-tarif';

export class MicroappFbsChargeType{
    application_charge_code: string;
    billing_system_charge_code: string;
    description:string;
    id:string;
    tarif:MicroappFbsTarif;
}